<template>
    <div>
        <div class="card">
            <div class="card-header">
                Calendário de Faturamento para {{ $util.getFormatDate($util.hoje()) }}
            </div>
            <ul class="list-group list-group-flush" v-if="dados && dados.length">
                <li class="list-group-item d-flex justify-content-between" v-for="(operadora, iox) in dados" :key="iox">
                    <div>
                        <a href="#" @click.prevent="abrirFaturamento(operadora)" class="card-link">
                            {{ operadora.search }}
                        </a>
                    </div>
                    <div>
                        <span>{{ operadora.parametro_fatura.envio_titulo }}</span>
                        
                        <template v-if="$store.state.user && $store.state.user.id_usuario == 1">
                            <span class="badge badge-secondary ml-2" v-if="operadora.parametro_fatura && operadora.parametro_fatura.parametro_fatura_calendario && operadora.parametro_fatura.parametro_fatura_calendario.id_parametro_fatura_calendario">
                                #{{ operadora.parametro_fatura.parametro_fatura_calendario.id_parametro_fatura_calendario }}
                            </span>
                            <span class="badge badge-secondary ml-2" v-if="operadora.parametro_fatura && operadora.parametro_fatura.ch_tipo_prazo">
                                {{ operadora.parametro_fatura.ch_tipo_prazo }}
                            </span>
                        </template>

                        <i class="fa fa-check text-success fa-fw ml-2" aria-hidden="true" v-if="operadora.faturas_enviadas.length"></i>
                        <i class="fa fa-calendar-plus-o text-secondary fa-fw ml-2" aria-hidden="true" v-else></i>
                    </div>
                </li>
            </ul>
            <div class="card-body" v-else>
                <div v-if="!carregando">
                    Nenhuma operadora encontrada.
                </div>
                <div v-else>
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() { 
        return { 
            dados: [], 
            carregando: false, 
        }
    },

    methods: { 
        abrirFaturamento(operadora) { 
            this.$emit('selecao', operadora.id_operadora);
        },

        load() {
            this.carregando = true;

            this.$util.loadItem(this, { 
                service: 'operadoras',
                func: 'calendario_envio',
            })
            .then(res => { 
                this.dados = res;
            })
            .finally(() => { 
                this.carregando = false;
            });
        }
    },

    mounted() { 
        this.load(); 
    }
}
</script>